import { c as _c } from "react/compiler-runtime";
import { Input as AInput, type InputProps } from 'antd';
import { classNames } from '@/util/utils';
function Input(t0) {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    const {
      className,
      ...t1
    } = t0;
    props = t1;
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames("rounded-none border-0 border-b border-gray-300 px-1 focus:ring-0", "focus:border-primary-8 focus:border-b-2", "placeholder:text-gray-400", "hover:border-gray-400", "[&.ant-input-status-error]:border-b-2! [&.ant-input-status-error]:border-rose-700!", "[&.ant-input-status-error]:border-t-0! [&.ant-input-status-error]:border-r-0! [&.ant-input-status-error]:border-l-0!");
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <AInput size="large" className={t1} {...props} />;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export { Input };